import { render, staticRenderFns } from "./StockInvoiceStakeholderSupplier.vue?vue&type=template&id=6093d708&scoped=true&"
import script from "./StockInvoiceStakeholderSupplier.vue?vue&type=script&lang=js&"
export * from "./StockInvoiceStakeholderSupplier.vue?vue&type=script&lang=js&"
import style0 from "./StockInvoiceStakeholderSupplier.vue?vue&type=style&index=0&id=6093d708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6093d708",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
